import { Box, Typography } from "@mui/material"
import { ContainmentFieldTitle, ContainmentFieldValue } from "lib/styles/shared"
import * as misc from "lib/util"

interface containmentFieldProps {
	title: string
	value: string
}

export function ContainmentField({ title, value }: containmentFieldProps): React.JSX.Element {
	return (
		<Box
			data-test-selector={`containment-field-${misc.ToKebabCase(title)}`}
			display="flex"
			alignItems="flex-start"
			gap={1}
		>
			<Typography sx={ContainmentFieldTitle}>{title}:</Typography>
			<Typography sx={ContainmentFieldValue}>{value}</Typography>
		</Box>
	)
}
